import { TaskerRegisterPhone } from "@/components/tasker/TaskerRegisterPhone";

export const RegisterPhone = TaskerRegisterPhone;
